<template>
  <div class="main-container minh-100">
    <div class="main-content-wrap">
      <div v-if="!submitSuccess" class="tech-offer-main tech-apply-main tech-apply-form flex-1">
        <h3>Apply to be one of our consultants!</h3>
        <p v-if="gigid">
          <span class="strong">Job Description:</span>
        </p>
        <div v-if="gigid && gig">
          <div style="line-height: 1.5; white-space: pre-wrap;" v-html="gig.data.task"></div>
        </div>
        <p>
          <span class="strong">Upload your resume here:</span>
        </p>
        <div class="form-inline">
          <div class="input-group">
            <div class="input-file">
              <input id="license" type="file" placeholder="image" @change="onImageChange($event)" />
              <label class="custom-file-label" for="license">
                {{fileName ? fileName :
                'Choose file'}}
              </label>
            </div>
          </div>
        </div>
        <!--        <p>-->
        <!--          <span class="strong">What Metro area are you applying:</span>-->
        <!--        </p>-->
        <!--        <div class="form-inline">-->
        <!--          <div>-->
        <!--            <model-select :options="metroOptions" v-model="metro"></model-select>-->
        <!--          </div>-->
        <!--        </div>-->
        <p>
          <span
            class="strong"
          >What kind of work are you looking for? (Part time to fill hours, full-time, off hours,etc)</span>
        </p>
        <div class="form-inline">
          <div>
            <textarea v-model="work" rows="5" />
          </div>
        </div>
        <p>
          <span
            class="strong"
          >Are you open to relocating to anther city for a long term 6-12 month project?</span>
        </p>
        <div class="form-inline">
          <div>
            <model-select :options="relocationOptions" v-model="relocation"></model-select>
          </div>
        </div>
        <p>
          <span class="strong">Do you have a LinkedIn profile? If so, enter below:</span>
        </p>
        <div class="form-inline">
          <div>
            <input v-model="linkedin" type="text" />
          </div>
        </div>
        <p>
          <span
            class="strong"
          >Enter your email here: (If you are picked for your interview, we'll send an email for you to book a interview slot)</span>
        </p>
        <div class="form-inline">
          <div>
            <input v-model="email" type="text" />
          </div>
        </div>
        <div class="error-info">
          <p v-for="(errTxt,index) in errArray" :key="index">{{errTxt}}</p>
        </div>
        <div class="form-inline tech-offer-btn">
          <!--<button
            @click="onSubmit"
            class="submit primary"
            :disabled="submitLoading"
          >{{submitLoading ? 'UPLOADING' : 'SUBMIT INFO'}}</button>-->
          <spinnerButton
              class="submit primary"
              :loading="submitLoading"
              @click.native="onSubmit"
          >SUBMIT INFO</spinnerButton>
        </div>
      </div>
      <div v-if="submitSuccess" class="tech-offer-main tech-apply-main flex-1">
        <h3>Apply success!</h3>
        <p>Apply success!</p>
        <p>
          <a href="javascript:void(0);" @click="onBack">back</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { db, storagePut, storageGetDownloadUrl } from "@/vendor/firebase";
import { randomString, getNameByEmail, validateEmail } from "@/utils/utils";
import * as database from "@/vendor/database";
import { httpGetNoToken } from "@/http/http";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  data() {
    return {
      submitSuccess: false,
      submitLoading: false,
      fileName: null,
      file: null,
      // metro: null,
      work: null,
      relocation: null,
      linkedin: null,
      email: null,
      gigid: null,
      gig: null,
      relocationOptions: []
      // metroOptions: []
    };
  },
  components: {
    ModelSelect,
    spinnerButton
  },
  mounted: function() {
    this.gigid = this.$route.params.gig;
    // this.$bind("gig", db.collection("gigs").doc(this.gigid));
    if(this.gigid){
      database.getDoc("gigs", this.gigid).then(result => {
        if (result.ok) {
          this.gig = result.data;
        }
      });
    }
    this.$store.commit("closeSidebar");
    this.initData();
  },
  methods: {
    initData: function() {
      this.relocationOptions = [
        {
          text: "Yes",
          value: true
        },
        {
          text: "No",
          value: false
        }
      ];
      // this.metroOptions = [];
      // db.collection("metros")
      //   .get()
      //   .then(snapshot => {
      //     snapshot.forEach(doc => {
      //       const data = doc.data();
      //       this.metroOptions.push({
      //         text: data.name,
      //         value: data.name
      //       });
      //     });
      //   });
    },
    onSubmit: async function() {
      this.errArray = [];
      // console.log("fileName", this.fileName);
      // console.log("file", this.file);
      // console.log("metro", this.metro);
      // console.log("work", this.work);
      // console.log("relocation", this.relocation);
      // console.log("linkedin", this.linkedin);
      // console.log("email", this.email);
      if (!this.fileName || !this.file) {
        this.errArray.push("please upload your resume!");
        // this.$toasted.global.toast_error({
        //   message: "please upload your resume"
        // });
        return;
      }
      // if (!this.metro) {
      //   this.$toasted.global.toast_error({ message: "please select a metro" });
      //   return;
      // }
      if (!this.work) {
        this.errArray.push("please input your work type!");
        // this.$toasted.global.toast_error({
        //   message: "please input your work type"
        // });
        return;
      }
      if (this.relocation == null || this.relocation == undefined) {
        this.errArray.push("please select relocating!");
        // this.$toasted.global.toast_error({
        //   message: "please select relocating"
        // });
        return;
      }
      if (!this.email) {
        this.errArray.push("please input your email!");
        // this.$toasted.global.toast_error({
        //   message: "please input your email"
        // });
        return;
      }
      if (!validateEmail(this.email)) {
        this.errArray.push("invalid email!");
        // this.$toasted.global.toast_error({
        //   message: "invalid email"
        // });
        return;
      }
      this.submitLoading = true;
      database
        .fieldExist("consultants", "email", this.email)
        .then(async result => {
          if (result) {
            this.submitLoading = false;
            this.errArray.push("this email has been used!");
            // this.$toasted.global.toast_error({
            //   message: "this email has been used"
            // });
          } else {
            // this.submitLoading = true;
            const fileName = randomString(10) + "_" + this.fileName;
            const putResult = await storagePut("resumes/", fileName, this.file);
            const urlResult = await storageGetDownloadUrl(
              "resumes/" + fileName
            );
            if (putResult.ok) {
              database
                .addDoc("applies", {
                  created: new Date().getTime() / 1000,
                  resume: fileName,
                  // metro: this.metro,
                  work: this.work,
                  is_relocation: this.relocation,
                  linkedin: this.linkedin,
                  email: this.email,
                  resume_url: urlResult.ok ? urlResult.data : null,
                  gig_id: this.gigid ? this.gigid : null,
                })
                .then(result => {
                  if (result.ok) {
                    const applyId = result.data;
                    httpGetNoToken("add_consultant_apply", {
                      email: this.email,
                      consultant: {
                        email: this.email,
                        apply: applyId
                      }
                    }).then(response => {
                      if (response.ok) {
                        let email = this.email;
                        database.getDoc("gigs", this.gigid).then(res => {
                          let public_apply = res.data.data.public_apply ? res.data.data.public_apply : [];
                          // console.log(res, public_apply);
                          database.getOnlyDocDataQuery("consultants", "email", email).then(re=>{
                            public_apply.push({
                              resume: fileName,
                              resume_url: urlResult.ok ? urlResult.data : null,
                              consultant: re.data.id,
                              email: email,
                            })
                            res.data.data.public_apply = public_apply;
                            // console.log(res);
                            database.setDoc("gigs", this.gigid, res.data.data);
                          });
                        })
                        this.fileName = null;
                        this.file = null;
                        // this.metro = null;
                        this.work = null;
                        this.relocation = null;
                        this.linkedin = null;
                        this.email = null;
                        this.submitSuccess = true;
                        this.submitLoading = false;
                        // this.$toasted.global.toast_success({
                        //   message: "submit success"
                        // });
                      } else {
                        this.submitLoading = false;
                        this.errArray.push(response.message);
                        // this.$toasted.global.toast_error({
                        //   message: response.message
                        // });
                      }
                    });
                  } else {
                    this.submitLoading = false;
                    this.errArray.push("add apply error");
                    // this.$toasted.global.toast_error({
                    //   message: "add apply error"
                    // });
                  }
                });
            } else {
              this.submitLoading = false;
              this.errArray.push("upload resume error!");
              // this.$toasted.global.toast_error({
              //   message: "upload resume error"
              // });
            }
          }
        });
    },
    onBack: function() {
      this.submitSuccess = false;
    },
    onImageChange: function(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      this.fileName = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = arg => {
        this.file = file;
      };
    }
  }
};
</script>
